import {Injectable} from '@angular/core';
import {config} from "../services.config";
import {grpc} from "@improbable-eng/grpc-web";
import Metadata = grpc.Metadata;

import {AccessToken, GatewayReq, StatusCode} from './'

import {GatewayRequest, GatewayReply, GatewayStreamRequest} from '@alpha/rpc/gateway_pb';
import {GatewayClient} from '@alpha/rpc/gateway_pb_service';

@Injectable({
    providedIn: 'root'
})
export class GatewayRpcService {

    client;

    constructor() {
        this.client = new GatewayClient(config.rpcUrl);
    }

    progress(percentage: number): number {
        var t=0;
        return percentage;
    }

    readFile(file: File) {
        return new Promise<Uint8Array>((resolve, reject) => {
            // Create file reader
            const reader = new FileReader();

            // Register event listeners
            //@ts-ignore
            reader.addEventListener("loadend", e => resolve(e.target.result));
            reader.addEventListener("error", reject);

            // Read file
            reader.readAsArrayBuffer(file);
        });
    }

    streamRequest<T, M>(req: GatewayReq<T, M>, file: File | null, authenticate = true): any {

        return new Promise((resolve, reject) => {

            const reader = new FileReader();

            if (file) {
                reader.readAsArrayBuffer(file);
            }

            const data = JSON.stringify(req.data);

            const request = new GatewayStreamRequest();
            request.setAction(String(req.action));
            request.setNamespace(req.namespace);
            request.setVersion(req.version);
            request.setData(data || ``);

            if (file) {
                const filename_split = file.name.split(".");
                request.setFilename(file.name);
                request.setFileExtension(filename_split[filename_split.length - 1]);
            }

            const rpc_access_token = localStorage.getItem("rpc.access_token");
            const rest_access_token = localStorage.getItem("current_account");

            const metadata = new Metadata();

            if (authenticate && rpc_access_token) {
                try {
                    const access_token: AccessToken = JSON.parse(rpc_access_token);
                    metadata.append("Authorization", `Bearer ${access_token.token}`);
                    if(rest_access_token){
                        metadata.append('X-Authorization', `${JSON.parse(rest_access_token).token}`)
                    }
                } catch (e) {
                    console.error("Invalid rpc authentication object.");
                }
            }

            const stream = this.client.streamRequest(metadata);
            stream.on("status", (status: any) => {
                switch (status.code) {
                    case StatusCode.Unauthenticated:
                        window.location.href = '/';
                        break;
                }
            });
            stream.on("data", (response: any) => {

                const data_object = response?.toObject();

                try {

                    if (!data_object) {
                        throw new Error("Cannot parse response");
                    }

                    const parsed = JSON.parse(data_object.response);

                    switch (data_object.status) {
                        case StatusCode.OK:
                            resolve(parsed);
                            break;
                        default:
                            console.log(data_object.status);
                            reject({status: 'error', response: `code: ${data_object.status} message: ${data_object.response}`});
                    }

                } catch (e) {
                    reject({status: 'error', response: `${e}`});
                }
            });

            reader.onprogress = (event) => {
                this.progress(Math.floor(event.loaded / event.total * 100));
            };

            reader.onloadend = (e) => {
                stream.end();
            };

            reader.onload = (event) => {
                const arrayBuffer: any = event?.target?.result;

                if (arrayBuffer != null) {
                    const chunk = new Uint8Array(arrayBuffer);

                    request.setFile(chunk);

                    stream.write(request);
                }

                // tslint:disable-next-line:no-shadowed-variable
                stream.on("end", (event: any) => {

                });

            };

            if (!file) {
                stream.write(request);
            }

        });

    }

    async request<T, M>(req: GatewayReq<T, M>, authenticate = true): Promise<any> {
        return new Promise((resolve, reject) => {

            const data = JSON.stringify(req.data);

            const request = new GatewayRequest();
            request.setVersion(req.version);
            request.setNamespace(req.namespace);
            request.setAction(String(req.action));
            request.setData(data || ``);

            const metadata = new Metadata();

            const rpc_access_token = localStorage.getItem("rpc.access_token");
            const rest_access_token = localStorage.getItem("current_account");

            if (authenticate && rpc_access_token) {
                try {
                    const access_token: AccessToken = JSON.parse(rpc_access_token);
                    metadata.append("Authorization", `Bearer ${access_token.token}`);
                    if(rest_access_token){
                        metadata.append('X-Authorization', `${JSON.parse(rest_access_token).token}`)
                    }
                } catch (e) {
                    console.error("Invalid rpc authentication object.", e);
                }
            }

            this.client.request(request, metadata, (err: any, response: any) => {

                if (err) {
                    switch (err.code) {
                        case StatusCode.Unauthenticated:
                            window.location.href = '/';
                            break;
                    }
                    reject(err);
                }

                const data_object = response?.toObject();

                try {

                    if (!data_object) {
                        throw new Error("Cannot parse response");
                    }

                    const parsed = JSON.parse(data_object.response);

                    switch (data_object.status) {
                        case StatusCode.OK:
                            resolve(parsed);
                            break;
                        default:
                            console.log(data_object.status);
                            reject({status: 'error', response: `code: ${data_object.status} message: ${data_object.response}`});
                    }

                } catch (e) {
                    reject({status: 'error', response: `${e}`});
                }

            });

        });

    }
}
